<template>
  <div>
    <MaskLayer class="bg-0" style="pointer-events: none;" v-if="dismissSec !== 0">
      <div class="position-absolute p-3 animate__animated animate__fadeIn" style="top:0; right: 0; max-width: 360px; pointer-events: auto;">
        <b-alert dismissible class="shadow-custom animate__pulse" :variant="variant" v-model="dismissSec">
          <div class="d-flex mx-n1">
            <div class="mx-1">
            </div>
            <div class="mx-1">
              <b>{{title}}</b>
              <div class="font-size-md">{{context}}</div>
            </div>
          </div>
        </b-alert>
      </div>
    </MaskLayer>
  </div>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';

export default {
  components: {
    MaskLayer,
  },
  data() {
    return {
      dismissSec: 0,
    };
  },
  props: {
    context: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'dark',
    },
  },
};
</script>
